import React from "react";
import { useParams } from "react-router-dom";
import Card from "../Card/Card";
import { Link } from "react-router-dom";
import './industryproducts.css';

const IndustryProducts = () => {

    const { industry } = useParams();

    const industryProducts = {
        "Crushers and Mining": {
            "description": "Lubricants tailored for mining and crushing machinery, ensuring optimal performance, reducing wear, and enhancing equipment lifespan. Designed to handle extreme conditions and heavy-duty operations.",
            "products": [
                {
                    "title": "Engine Oil 15w40",
                    "description": "High-performance oil for diesel trucks, farm tractors, and passenger cars. Provides excellent engine protection and reduces wear under demanding conditions."
                },
                {
                    "title": "Engine Oil 20w40",
                    "description": "Versatile oil designed for commercial vehicles, tractors, and gensets. Offers reliable performance and extends engine life in harsh environments."
                },
                {
                    "title": "Gear Oil 90/140/80w90/85w140",
                    "description": "Specifically formulated for manual transmissions and industrial machinery. Ensures smooth gear operations and protects against friction and wear."
                },
                {
                    "title": "Grease EPL2",
                    "description": "Premium-grade grease suitable for bearings, chassis, and marine applications. Provides superior lubrication and prevents rust and corrosion."
                },
                {
                    "title": "AdBLU",
                    "description": "An advanced solution to reduce harmful emissions in diesel vehicles. Improves combustion efficiency and supports environmental compliance."
                },
                {
                    "title": "Hydraulic Oil 32/46/68",
                    "description": "High-quality oil for forklifts, hydraulic lifts, and industrial machinery. Ensures smooth operations and prevents wear in hydraulic systems."
                },
                {
                    "title": "Castrol Triol PD EP2 Grease",
                    "description": "Specialized grease for bearings in high-stress and high-speed applications. Delivers exceptional performance under extreme conditions."
                }
            ]
        },
        // "Steel and Iron Manufacturing": {
        //     "description": "Lubricants designed for heavy-duty steel and iron manufacturing machinery. Offers exceptional protection for cranes, excavators, compressors, and more.",
        //     "products": [
        //         {
        //             "title": "Hydraulic Oil ISO 46",
        //             "description": "Enhances the smooth operation of heavy equipment like cranes and excavators. Ensures reliable performance even under high-pressure conditions."
        //         },
        //         {
        //             "title": "Grease for Construction Equipment",
        //             "description": "Heavy-duty grease designed to protect moving parts from wear and tear. Ideal for use in demanding construction environments."
        //         },
        //         {
        //             "title": "Compressor Oil",
        //             "description": "Improves efficiency and reduces wear in compressors used in industrial applications. Provides long-lasting protection and smooth operations."
        //         },
        //         {
        //             "title": "Concrete Release Oil",
        //             "description": "Prevents concrete buildup on forms and molds, ensuring clean and easy removal. Essential for construction and manufacturing processes."
        //         },
        //         {
        //             "title": "Chain Lubricant",
        //             "description": "Minimizes friction and wear in chains used in construction machinery. Extends chain life and enhances performance."
        //         },
        //         {
        //             "title": "Bearing Lubricant",
        //             "description": "Ensures smooth operation and rust prevention in industrial bearings. Designed for high-stress environments and heavy machinery."
        //         },
        //         {
        //             "title": "Engine Oil 15W-40",
        //             "description": "Heavy-duty engine oil for high-load engines in construction machinery. Provides superior protection against wear and tear."
        //         },
        //         {
        //             "title": "Grease for Bearings & Joints",
        //             "description": "Formulated for industrial machinery joints and bearings. Offers excellent lubrication and protection in high-stress applications."
        //         }
        //     ]
        // },
        "Rubber": {
            "description": "Specialized oils and lubricants for rubber processing and manufacturing. Widely used in producing tyres, mats, hoses, and automotive components.",
            "products": [
                {
                    "title": "Aromatic Oil",
                    "description": "Used in automotive components, tyres, and conveyor belts. Enhances rubber flexibility and performance in industrial applications."
                },
                {
                    "title": "Paraffanic Oil",
                    "description": "A reliable oil for rubber compounding, footwear, and textiles. Improves processing efficiency and product durability."
                },
                {
                    "title": "Naphtenic Oil",
                    "description": "Widely applied in rubber parts, tyres, and specialty chemicals. Offers superior compatibility with a range of materials."
                }
            ]
        },
        "Logistics and Transportation": {
            "description": "Essential oils and greases for transportation vehicles, ensuring smooth operation and extending the lifespan of critical components.",
            "products": [
                {
                    "title": "Engine Oil 15w40",
                    "description": "Premium oil for diesel trucks, farm tractors, and passenger cars. Provides excellent protection and performance under heavy loads."
                },
                {
                    "title": "Engine Oil 20w40",
                    "description": "Heavy-duty oil designed for vehicles and gensets. Offers robust engine protection and performance in tough operating conditions."
                },
                {
                    "title": "Gear Oil 90/140/80w90/85w140",
                    "description": "High-pressure oil for manual transmissions and machinery. Ensures smooth operations and reduces friction in critical components."
                },
                {
                    "title": "Grease EPL2",
                    "description": "Multipurpose grease for automotive and industrial applications. Protects parts against wear and prevents rust and corrosion."
                },
                {
                    "title": "AdBLU",
                    "description": "An emission-reduction solution for diesel vehicles. Supports cleaner combustion and enhances environmental compliance."
                }
            ]
        },
        "Cold Storage Plants": {
            "description": "Lubricants formulated for refrigeration systems, ensuring efficient performance and reliability in industrial cold storage operations.",
            "products": [
                {
                    "title": "Ammonia Cooling Compressor Oil",
                    "description": "Specially designed for refrigeration systems and cold storage facilities. Ensures smooth operation and reduces wear in compressors."
                }
            ]
        }
    };                  
    
    return(
        <div className="industry-products-container">
            <Link to="/#products" className="back-nav"> ↩ Back to Industries</Link>
            <h2>{industry}</h2>
            <p className="description">{industryProducts[industry].description}</p>
            <div className="industry-products-content">
            {
                industryProducts[industry].products.map(product => <Card data={product} key={product.title}/>)
            }
            </div>
        </div>
    )
};  

export default IndustryProducts;